export default __webpack_public_path__ + "static/media/savin-logo.04756723.png";